import { formatPrice, formatPriceRemoveComma} from "services/util/trips.service";
import { ICarList } from "./SixtFlow.models";

export function getHomeSixt(t: any) {
  return {
    name: t("getHomeSixt.name"),
    desc1: t("getHomeSixt.desc1"),
    desc2: t("getHomeSixt.desc2"),
    seeMore: t("getHomeSixt.seeMore"),
  };
}

export function steps(t: any) {
  return [
    { icon: t("steps.0.icon"), text: t("steps.0.text") },
    { icon: t("steps.1.icon"), text: t("steps.1.text") },
    { icon: t("steps.2.icon"), text: t("steps.2.text") },
    { icon: t("steps.3.icon"), text: t("steps.3.text") },
    { icon: t("steps.4.icon"), text: t("steps.4.text") },
    { icon: t("steps.5.icon"), text: t("steps.5.text") },
    { icon: t("steps.6.icon"), text: t("steps.6.text") },
  ];
}

export function getFooterLiterals(t: any) {
  return {
    title: t("getFooterLiterals.title"),
    showPrivacyPolicyText: t("getFooterLiterals.showPrivacyPolicyText"),
    showLegalConditionsText: t("getFooterLiterals.showLegalConditionsText"),
    showCookiePolicyText: t("getFooterLiterals.showCookiePolicyText"),
    linkPrivacyPolicyText: "https://www.docomobility.com/es/privacidad",
    linkLegalConditionsText:
      "https://www.docomobility.com/es/terminos-y-condiciones",
    linkCookiePolicyText: "https://www.docomobility.com/es/politica-de-cookies",
  };
}

export function getMyReservationLiterals(t: any) {
  return {
    backTitle: t("getMyReservationLiterals.backTitle"),
    title: t("getMyReservationLiterals.title"),
    desc: t("getMyReservationLiterals.desc"),
    form: {
      pickUpMyCarTitle: t("getMyReservationLiterals.form.pickUpMyCarTitle"),
      pickUpMyCarPlaceholder: t(
        "getMyReservationLiterals.form.pickUpMyCarPlaceholder"
      ),
      pickUpDate: t("getMyReservationLiterals.form.pickUpDate"),
      pickupTitle: t("getMyReservationLiterals.form.pickupTitle"),
      pickUpTime: {
        selector: t("getMyReservationLiterals.form.pickUpTime.selector"),
        options: [
          {
            code: t("getMyReservationLiterals.form.pickUpTime.options.0.code"),
            text: t("getMyReservationLiterals.form.pickUpTime.options.0.text"),
            selected: true,
          },
        ],
      },
      returnMyCarTitle: t("getMyReservationLiterals.form.returnMyCarTitle"),
      returnMyCarPlaceholder: t(
        "getMyReservationLiterals.form.returnMyCarPlaceholder"
      ),
      returnTitle: t("getMyReservationLiterals.form.returnTitle"),
      pickupInfo: t("getMyReservationLiterals.form.pickupInfo"),
      returnDate: t("getMyReservationLiterals.form.returnDate"),
      returnTime: {
        selector: t("getMyReservationLiterals.form.returnTime.selector"),
        options: [
          {
            code: t("getMyReservationLiterals.form.returnTime.options.0.code"),
            text: t("getMyReservationLiterals.form.returnTime.options.0.text"),
            selected: true,
          },
        ],
      },
      returnCollectionPointTitle: t(
        "getMyReservationLiterals.form.returnCollectionPointTitle"
      ),
      driverAgeTitle: t("getMyReservationLiterals.form.driverAgeTitle"),
      required: t("getMyReservationLiterals.form.required"),
      continueButton: t("getMyReservationLiterals.form.continueButton"),
      day: t("getMyReservationLiterals.form.day"),
      month: t("getMyReservationLiterals.form.month"),
      year: t("getMyReservationLiterals.form.year"),
    },
  };
}

export function getAgeInfoModalLiterals(t: any) {
  return {
    title: t("getAgeInfoModalLiterals.title"),
    description: t("getAgeInfoModalLiterals.description"),
    buttons: [
      {
        text: t("getAgeInfoModalLiterals.buttons.0.text"),
      },
    ],
  };
}

export function getVehicleLiterals(t: any) {
  return {
    title: t("getVehicleLiterals.title"),
    desc: t("getVehicleLiterals.desc"),
    filter: t("getVehicleLiterals.filter"),
    continueButton: t("getVehicleLiterals.continueButton"),
    idDesglose: t("getVehicleLiterals.idDesglose"),
    item1: t("getNoResultLiterals.item1"),
  };
}

export function getVehicleDetailsLiteral(t: any) {
  return {
    dayPrice: t("getVehicleDetailsLiteral.dayPrice"),
    kmInclude: t("getVehicleDetailsLiteral.kmInclude"),
    automatic: t("getVehicleDetailsLiteral.isAutomatic.automatic"),
    manual: t("getVehicleDetailsLiteral.isAutomatic.manual"),
    isElectric: t("getVehicleDetailsLiteral.isElectric.isElectric"),
    noElectric: t("getVehicleDetailsLiteral.isElectric.noElectric"),
    passengers: t("getVehicleDetailsLiteral.passengers"),
    baggages: t("getVehicleDetailsLiteral.baggages"),
    ageDriver: t("getVehicleDetailsLiteral.ageDriver"),
    totalPrice: t("getVehicleDetailsLiteral.totalPrice"),
  
  };
}

export function getSixtFilterLiterals(t: any) {
  return {
    title: t("getSixtFilterLiterals.title"),
    titleTransport: t("getSixtFilterLiterals.titleTransport"),
    desc: t("getSixtFilterLiterals.desc"),
    titleOthers: t("getSixtFilterLiterals.titleOthers"),
    othersFilters: {
      isElectric: t("getSixtFilterLiterals.othersFilters.isElectric"),
      isAutomatic: t("getSixtFilterLiterals.othersFilters.isAutomatic"),
    },
    titlePlaces: t("getSixtFilterLiterals.titlePlaces"),
    min: t("getSixtFilterLiterals.min"),
    max: t("getSixtFilterLiterals.max"),
    baggages: t("getSixtFilterLiterals.baggages"),
    okButton: t("getSixtFilterLiterals.okButton"),
    restart: t("getSixtFilterLiterals.restart"),
  };
}

export function getNoResultLiteralsFilter(t: any) {
  return {
    title: t("getNoResultLiteralsFilter.title"),
    item1: t("getNoResultLiteralsFilter.item1"),
  };
}
export function getServiceError(t: any) {
  return {
    title: t("getServiceError.title"),
    description: t("getServiceError.description"),
    img: {
      alt: t("getServiceError.alt"),
    },
    button: {
      text: t("getServiceError.button.text"),
    },
  };
}

export function getDriversLiterals(t: any) {
  return {
    title: t("getDriversLiterals.title"),
    subTitle: t("getDriversLiterals.subTitle"),
    dataTitle: t("getDriversLiterals.dataTitle"),
    cleanButton: t("getDriversLiterals.cleanButton"),
    invoiceTitle: t("getDriversLiterals.invoiceTitle"),
    continueButton: t("getDriversLiterals.continueButton"),
  };
}

export function getInvoicesLiteral(t: any) {
  return {
    streetAddress: t("getInvoicesLiteral.streetAddress"),
    postalCode: t("getInvoicesLiteral.postalCode"),
    locality: t("getInvoicesLiteral.locality"),
    region: t("getInvoicesLiteral.region"),
    country: t("getInvoicesLiteral.country"),
  };
}

export function getInputsDriverLiterals(t: any) {
  return {
    literals: {
      personalinfo: {
        form: {
          formErrors: {
            required: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.required"
            ),
            name: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.name"
            ),
            surname: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.surname"
            ),
            surname2: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.surname2"
            ),
            day: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.day"
            ),
            month: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.month"
            ),
            year: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.year"
            ),
            prefixNumber: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.prefixNumber"
            ),
            phoneNumber: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.phoneNumber"
            ),
            email: t(
              "getInputsDriverLiterals.literals.personalinfo.form.formErrors.email"
            ),
          },
          email: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.email.label"
            ),
          },
          name: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.name.label"
            ),
          },
          surname: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.surname.label"
            ),
          },
          surname2: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.surname2.label"
            ),
          },
          prefix: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.prefix.label"
            ),
          },
          phone: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.phone.label"
            ),
          },
          day: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.day.label"
            ),
          },
          month: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.month.label"
            ),
          },
          year: {
            label: t(
              "getInputsDriverLiterals.literals.personalinfo.form.year.label"
            ),
          },
        },
      },
    },
  };
}

// Funcion para los modales

export function getSelectPlaceModalLiterals(t: any) {
  return {
    title: t("getSelectPlaceModalLiterals.title"),
    description: t("getSelectPlaceModalLiterals.description"),
    buttons: [
      {
        text: t("getSelectPlaceModalLiterals.buttons.0.text"),
      },
    ],
  };
}

export function getDateBirthModalLiterals(t: any) {
  return {
    title: t("getDateBirthModalLiterals.title"),
    description: t("getDateBirthModalLiterals.description"),
    buttons: [
      {
        text: t("getDateBirthModalLiterals.buttons.0.text"),
      },
    ],
  };
}

export function getNoCarModalLiterals(t: any) {
  return {
    title: t("getNoCarModalLiterals.title"),
    description: t("getNoCarModalLiterals.description"),
    buttons: [
      {
        text: t("getNoCarModalLiterals.buttons.0.text"),
      },
    ],
  };
}
export function getKmModalLiterals(t: any) {
  return {
    title: t("getKmModalLiterals.title"),
    description: t("getKmModalLiterals.description"),
    buttons: [
      {
        text: t("getKmModalLiterals.buttons.0.text"),
      },
    ],
  };
}
export function getInsuranceModalLiterals(t: any) {
  return {
    title: t("getInsuranceModalLiterals.title"),
    description: t("getInsuranceModalLiterals.description"),
    buttons: [
      {
        text: t("getInsuranceModalLiterals.buttons.0.text"),
      },
    ],
  };
}
export function getDriverModalLiterals(t: any) {
  return {
    title: t("getDriverModalLiterals.title"),
    description: t("getDriverModalLiterals.description"),
    buttons: [
      {
        text: t("getDriverModalLiterals.buttons.0.text"),
      },
    ],
  };
}
export function getPickupReturnLiterals(t: any) {
  return {
    pickupTitle: t("getPickupReturnLiterals.pickupTitle"),
    info: [
      {
        day: t("getPickupReturnLiterals.info.0.day"),
      },
      {
        day: t("getPickupReturnLiterals.info.1.day"),
      },
      {
        day: t("getPickupReturnLiterals.info.2.day"),
      },
      {
        day: t("getPickupReturnLiterals.info.3.day"),
      },
      {
        day: t("getPickupReturnLiterals.info.4.day"),
      },
      {
        day: t("getPickupReturnLiterals.info.5.day"),
      },
      {
        day: t("getPickupReturnLiterals.info.6.day"),
      },
    ],
    returnTitle: t("getPickupReturnLiterals.returnTitle"),
    closeButton: t("getPickupReturnLiterals.closeButton"),
  };
}

export function getSixtKmPlanLiterals(t: any) {
  return {
    title: t("getSixtKmPlanLiterals.title"),
    description: t("getSixtKmPlanLiterals.description"),
    noDataDescription: t("getSixtKmPlanLiterals.noDataDescription"),
    continueButton: t("getSixtKmPlanLiterals.continueButton"),
    idDesglose: t("getSixtKmPlanLiterals.idDesglose"),
  };
}

export function getSixtCarInsuranceLiterals(t: any) {
  return {
    title: t("getSixtCarInsuranceLiterals.title"),
    description: t("getSixtCarInsuranceLiterals.description"),
    noDataDescription: t("getSixtCarInsuranceLiterals.noDataDescription"),
    continueButton: t("getSixtCarInsuranceLiterals.continueButton"),
    idDesglose: t("getSixtCarInsuranceLiterals.idDesglose"),
    day: t("getSixtCarInsuranceLiterals.day"),
  };
}

export function getSixtExtrasLiterals(t: any) {
  return {
    title: t("getSixtExtrasLiterals.title"),
    description: t("getSixtExtrasLiterals.description"),
    noDataDescription: t("getSixtExtrasLiterals.noDataDescription"),
    continueButton: t("getSixtExtrasLiterals.continueButton"),
    idDesglose: t("getSixtExtrasLiterals.idDesglose"),
    day: t("getSixtExtrasLiterals.day"),
    counter: {
      quantity: t("getSixtExtrasLiterals.counter.quantity"),
      pricePerUnit: t("getSixtExtrasLiterals.counter.pricePerUnit"),
    },
    people: t("getSixtExtrasLiterals.people"),
  };
}

export function getSummaryLiterals(t: any) {
  return {
    titleTopSection: t("getSummaryLiterals.titleTopSection"),
    departureText: t("getSummaryLiterals.departureText"),
    returnText: t("getSummaryLiterals.returnText"),
    totalReserveTitle: t("getSummaryLiterals.totalReserveTitle"),
    titleAccordionOpen: t("getSummaryLiterals.titleAccordionOpen"),
    titleAccordionClose: t("getSummaryLiterals.titleAccordionClose"),
    diffDay: t("getSummaryLiterals.diffDay"),
    diffDays: t("getSummaryLiterals.diffDays"),
    continueButton: t("getVehicleLiterals.continueButton"),
    reserve:t("getSixtPlannerPaymentLiterals.continueButton"),
    skirt:{
      part1:t("getSixtPlannerPaymentLiterals.skirt.part1"),
      part2:t("getSixtPlannerPaymentLiterals.skirt.part2"),
      part3:t("getSixtPlannerPaymentLiterals.skirt.part3"),
      part4:t("getSixtPlannerPaymentLiterals.skirt.part4"),
    },
    titleDropdown: t("getSixtPlannerPaymentLiterals.titleDropdown"),
    termsCondition:{
      part1:t("getSixtPlannerPaymentLiterals.termsCondition.part1"),
      part2:t("getSixtPlannerPaymentLiterals.termsCondition.part2"),
      part3:t("getSixtPlannerPaymentLiterals.termsCondition.part3"),
      part4:t("getSixtPlannerPaymentLiterals.termsCondition.part4"),
      part5:t("getSixtPlannerPaymentLiterals.termsCondition.part5"),
      part6:t("getSixtPlannerPaymentLiterals.termsCondition.part6"),
      urlRent:t("getSixtPlannerPaymentLiterals.termsCondition.urlRent"),
      urlConditions:t("getSixtPlannerPaymentLiterals.termsCondition.urlConditions"),
      urlPolicy:t("getSixtPlannerPaymentLiterals.termsCondition.urlPolicy"),
    }
  };
}


export function getSixtPlannerPaymentLiterals(t: any) {
  return {
    title: t("getSixtPlannerPaymentLiterals.title"),
    continueButton: t("getSixtPlannerPaymentLiterals.continueButton"),
    includedReservation:t("getSixtPlannerPaymentLiterals.includedReservation"),
    skirt:{
      part1:t("getSixtPlannerPaymentLiterals.skirt.part1"),
      part2:t("getSixtPlannerPaymentLiterals.skirt.part2"),
      part3:t("getSixtPlannerPaymentLiterals.skirt.part3"),
      part4:t("getSixtPlannerPaymentLiterals.skirt.part4"),
    },
    titleDropdown: t("getSixtPlannerPaymentLiterals.titleDropdown"),
    termsCondition:{
      part1:t("getSixtPlannerPaymentLiterals.termsCondition.part1"),
      part2:t("getSixtPlannerPaymentLiterals.termsCondition.part2"),
      part3:t("getSixtPlannerPaymentLiterals.termsCondition.part3"),
      part4:t("getSixtPlannerPaymentLiterals.termsCondition.part4"),
      part5:t("getSixtPlannerPaymentLiterals.termsCondition.part5"),
      part6:t("getSixtPlannerPaymentLiterals.termsCondition.part6"),
      urlRent:t("getSixtPlannerPaymentLiterals.termsCondition.urlRent"),
      urlConditions:t("getSixtPlannerPaymentLiterals.termsCondition.urlConditions"),
      urlPolicy:t("getSixtPlannerPaymentLiterals.termsCondition.urlPolicy"),
    }
  };
}

export function getCreateSixtActivityLiterals(t: any) {
  return {
    title: t("getCreateSixtActivityLiterals.title"),
    description: t("getCreateSixtActivityLiterals.description"),
    buttons: [
      {
        text: t("getCreateSixtActivityLiterals.buttons.0.text"),
      },
    ],
  };
}

export function getCancelSixt(t:any) {
  return {
    title: t("getCancelSixt.title"),
    description: t("getCancelSixt.description"),
    percentage: t("getCancelSixt.percentage"),
    cancelButton: t("getCancelSixt.cancelButton"),
    back: t("getCancelSixt.back")
  }
}

/**
 * Logica para actualizar el desglose al editar datos ya marcados o nuevos
 * @param datosActuales
 * @param datoNuevo
 * @returns
 */
export function updateBreakdown(datosActuales: any, datoNuevo: any) {
  var array: any;
  //Con este FindIndex busco la posicion que queremos borrar
  var posicionBorrar = datosActuales.findIndex(
    (item: any) => item.id === datoNuevo.id
  );
  if (posicionBorrar == -1) {
    array = datosActuales.concat(datoNuevo);
  } else {
    array = datosActuales[posicionBorrar] = undefined;
    array = datosActuales.concat(datoNuevo);
    //Para eliminar los nulls
    array = array.filter((e: any) => e != null);
  }
  return array;
}

export function updateBreakdownTranslation(datosActuales: any, t: any) {
  let result = {};
  if (datosActuales.myReservation) {
    const date = new Date(datosActuales?.myReservation.dateDearture);
    result = {
      ...datosActuales,
      myReservation: {
        ...datosActuales.myReservation,
        // dateDearture:new Date(datosActuales?.myReservation.dateDearture).toLocaleDateString(sessionLanguageMapping(), {month: "short",day: "2-digit",}),
        //dateReturn:new Date(datosActuales?.myReservation.dateReturn).toLocaleDateString(sessionLanguageMapping(), {month: "short",day: "2-digit",}),
      },
    };

    return result;
  }
}

/**
 * Funcion para eliminar los datos del desglose al navegar por los steps
 * @param numeroNuevo
 * @param datosDesglose
 * @returns
 */
export function updateBreakdownStep(numeroNuevo: any, datosDesglose: any) {
  let result;
  result = datosDesglose.slice(0, numeroNuevo - 1);
  return result;
}


/**
 * Funcion para actualizar la variables de datos seleccionados al navegar por el steps
 * @param numeroNuevo 
 * @param datos 
 * @returns 
 */
export function updateDetailsStep(numeroNuevo: any, datos: any) {
  let result={};
  switch (numeroNuevo) {
    case 1:
      result = {
        myReservation: datos.myReservation,
        sixtVehicle:datos.sixtVehicle
      };

      break;
    case 2:
      result = {
        myReservation: datos.myReservation,
        sixtKmPlan:datos.sixtKmPlan,
        sixtVehicle:datos.sixtVehicle
      };

      break;
    case 3:
      result = {
        myReservation: datos.myReservation,
        sixtKmPlan:datos.sixtKmPlan,
        sixtCarInsurance:datos.sixtCarInsurance,
        sixtVehicle:datos.sixtVehicle
      };

      break;
    case 4:
      result = {
        myReservation: datos.myReservation,
        sixtKmPlan:datos.sixtKmPlan,
        sixtCarInsurance:datos.sixtCarInsurance,
        sixtCarExtras:datos.sixtCarExtras,
        sixtVehicle:datos.sixtVehicle
      };

      break;
    case 5:
      result = {
        myReservation: datos.myReservation,
        sixtKmPlan:datos.sixtKmPlan,
        sixtCarInsurance:datos.sixtCarInsurance,
        sixtCarExtras:datos.sixtCarExtras,
        sixtDriver:datos.sixtDriver,
        sixtVehicle:datos.sixtVehicle
      };

      break;

    default:
      break;
  }

  return result;
}

/**
 * Funcion donde mapeamos la lista de coches
 * @param data 
 * @returns lista de coches
 */
export function mappingCarList(data: any,t:any) {
  const result: ICarList[] = data.map(
    (car: any) => {
      return {
        id:car.itemParameters.offer.id,
        description:car.description,
        contextValue: car.contextValue,
        carName: car.name,
        carStyle: car.itemParameters.offer.vehicleGroupInfo.groupInfo.bodyStyleTitle,
        carStyleId: car.itemParameters.offer.vehicleGroupInfo.groupInfo.bodyStyle,
        totalForDay: formatPrice(car.itemParameters.offer.prices.dayPrice.amount),
        image: car.itemParameters.offer.vehicleGroupInfo.groupInfo.imageUrl,
        isAutomatic: car.itemParameters.offer.vehicleGroupInfo.groupInfo.isAutomatic,
        isElectric: car.itemParameters.offer.vehicleGroupInfo.groupInfo.isElectric,
        electricMaxRange: car.itemParameters.offer.vehicleGroupInfo.groupInfo.maxRangeWltp,
        ageDriver: car.itemParameters.offer.vehicleGroupInfo.groupInfo.driverRequirements.minAge,
        passengers: car.itemParameters.offer.vehicleGroupInfo.groupInfo.maxPassengers,
        bags: car.itemParameters.offer.vehicleGroupInfo.groupInfo.baggage.bags,
        total:  formatPriceRemoveComma(car.itemParameters.offer.prices.totalPrice.amount),
        mileagePlans:car.itemParameters.offer.mileagePlans.map((item: any) => {
          return {
            ...item,
            price:{
              ...item.price,
              literal:secureMapping(item.price.amount)
            }
           
          };
        }),
        charges: car.itemParameters.offer.charges.map((item: any) => {
          return {
            ...item,
            price:{
              ...item.price,
              literal:unitKeyMapping(item.price.unitKey,item.price.amount,t)
            }
           
          };
        }),
        itemParameters:{
          documents:car.itemParameters.documents,
          offer:{
            acrissCode:car.itemParameters.offer.acrissCode,
            depositAmount:car.itemParameters.offer.depositAmount,
            id:car.itemParameters.offer.id,
            isOnRequest:car.itemParameters.offer.isOnRequest,
            prices:car.itemParameters.offer.prices,
            rentalDays:car.itemParameters.offer.rentalDays,
            rentalHours:car.itemParameters.offer.rentalHours,
            title:car.itemParameters.offer.title,
            vehicleGroupInfo:car.itemParameters.offer.vehicleGroupInfo,
            youngDriverFeeApplied:car.itemParameters.offer.youngDriverFeeApplied,
            payment:car.itemParameters.offer.payment,  
          },
          
          
        },
        includes:car.itemParameters.offer.included    
      };
    }
  );
return result

}

export function mappingFilterList(data: any) {
  const result: ICarList[] = data.map(
    (car: any) => {
      return {
        id: car.itemParameters.offer.vehicleGroupInfo.groupInfo.bodyStyle,
        carStyle:
          car.itemParameters.offer.vehicleGroupInfo.groupInfo.bodyStyle,
        text: car.itemParameters.offer.vehicleGroupInfo.groupInfo
          .bodyStyleTitle,
        selected: true,
        passengers:
          car.itemParameters.offer.vehicleGroupInfo.groupInfo.maxPassengers,
        baggage:
          car.itemParameters.offer.vehicleGroupInfo.groupInfo.baggage.bags,
        isAutomatic:
          car.itemParameters.offer.vehicleGroupInfo.groupInfo.isAutomatic,
        isElectric:
          car.itemParameters.offer.vehicleGroupInfo.groupInfo.isElectric,
      };
    }
  );

return result

}


export function createBodyPost (carSelectedDetails:any) {
  let extras =  [    
          {
            type: carSelectedDetails.sixtKmPlan.id,
            value: "1"
          },
          {
            type: carSelectedDetails.sixtCarInsurance.id,
            value: "1"
          },
          {
            type: "pickUpPoint",
            value: carSelectedDetails.myReservation.pickup
          },
          {
            type: "returnPoint",
            value: carSelectedDetails.myReservation.return
          },
          {
            type: "pickUpDate",
            value: formatDate(carSelectedDetails?.myReservation.pickupDate,carSelectedDetails?.myReservation?.timePickupAux),
          },
          {
            type: "returnDate",
            value:formatDate(carSelectedDetails?.myReservation.dateReturn,carSelectedDetails?.myReservation?.timeReturnAux),
          }   
];

let extrasList = carSelectedDetails.sixtCarExtras;

extrasList.forEach((element:any) => {
    extras.push({
        type: element.id,
        value: element.quantity.toString()
    })    
});  

let extrasCharges = carSelectedDetails.sixtCarExtras;
let insuranceCharges = carSelectedDetails.sixtCarInsurance;

let chargesList = extrasCharges.concat(insuranceCharges);

  let aux = {
    outwardJourney: {
      carRentInformation: {
        contextType: "BOOKEE_CONTEXT",
        contextValue: carSelectedDetails?.sixtVehicle.contextValue,
        provider: "sixt",
        name: carSelectedDetails?.sixtVehicle.carName,
        description: carSelectedDetails?.sixtVehicle.carName,
        price: {
          gross: carSelectedDetails?.sixtVehicle.totalPrice,
          currency: "EUR",
        },
        itemParameters: {
          documents: {
            termsAndConditions:carSelectedDetails?.sixtVehicle.itemParameters.documents.termsAndConditions,
            dataPrivacy:carSelectedDetails?.sixtVehicle.itemParameters.documents.dataPrivacy,
            rentalInformation: carSelectedDetails?.sixtVehicle.itemParameters.documents.rentalInformation,
          },
          offer: {
            id: carSelectedDetails?.sixtVehicle.itemParameters.offer.id,
            acrissCode: carSelectedDetails?.sixtVehicle.itemParameters.offer.acrissCode,
            rentalDays: carSelectedDetails?.sixtVehicle.itemParameters.offer.rentalDays,
            rentalHours: carSelectedDetails?.sixtVehicle.itemParameters.offer.rentalHours,
            title: carSelectedDetails?.sixtVehicle.carName,
            vehicleGroupInfo: {
              type: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.type,
              groupInfo: {
                vehicleGroup: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.vehicleGroup,
                bodyStyle: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.bodyStyle,
                bodyStyleTitle: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.bodyStyleTitle,
                isLuxury: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.isLuxury,
                hasAirConditioning: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.hasAirConditioning,
                isAutomatic: carSelectedDetails?.sixtVehicle.isAutomatic,
                hasNavigationSystem: false,
                isModelGuaranteed: false,
                maxPassengers: carSelectedDetails?.sixtVehicle.passengers,
                doors: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.doors,
                driverRequirements: {
                  minAge: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.driverRequirements.minAge,
                  youngDriverAge: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.driverRequirements.youngDriverAge,
                },
                examples: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.examples,
                imageUrl:carSelectedDetails?.sixtVehicle.image,
                baggage: {
                  bags: carSelectedDetails?.sixtVehicle.bags,
                },
                isElectric: carSelectedDetails?.sixtVehicle.carName,
                maxRangeWltp: carSelectedDetails?.sixtVehicle.itemParameters.offer.vehicleGroupInfo.groupInfo.maxRangeWltp,
              },
            },
            prices:carSelectedDetails?.sixtVehicle.itemParameters.offer.prices,
            included:carSelectedDetails.sixtKmPlan,
            payment:carSelectedDetails?.sixtVehicle.itemParameters.offer.payment,
            isOnRequest: carSelectedDetails?.sixtVehicle.itemParameters.offer.isOnRequest,
            depositAmount: carSelectedDetails?.sixtVehicle.itemParameters.offer.depositAmount,
            youngDriverFeeApplied: carSelectedDetails?.sixtVehicle.itemParameters.offer.youngDriverFeeApplied,
            charges: chargesList,
            mileagePlans:carSelectedDetails?.sixtKmPlan
          },
        },
      },
      selectedTariff:[
        {
          idLeg: 0,
          provider: "sixt",
          contextType: "BOOKEE_CONTEXT",
          tickets: [
            {
                context: carSelectedDetails.sixtVehicle.contextValue,
                extras: extras
            }
          ]        
        }
      ]
    },
    travellers: [
      {
        type: "ADULT",
        personalInformation: {
          customerFullName: {
            firstSurname: carSelectedDetails?.sixtDriver?.surname,
            name: carSelectedDetails?.sixtDriver?.name,
            secondSurname: carSelectedDetails?.sixtDriver?.surname2,
          },
          email: carSelectedDetails?.sixtDriver?.email,
          phone: {
            number: carSelectedDetails?.sixtDriver?.phoneNumber,
            prefix: carSelectedDetails?.sixtDriver?.prefixNumber,
          },
          birthDate: `${carSelectedDetails?.myReservation?.year}-${carSelectedDetails?.myReservation?.month}-${carSelectedDetails?.myReservation?.day}`
        },
      },
    ],  
  };

  return aux
};

export function formatDate (date: Date, time: any) {
    let dateToFormat = new Date(date);
    dateToFormat.setHours(time.hours);
    dateToFormat.setMinutes(time.minutes);      
   
   return `${dateToFormat.toISOString().substring(0,16)}:00Z`;
}

export function formatDatePlus15 (date: Date, time: any) {
    let newTime = {
        hours: time.hours,
        minutes: parseFloat(time.minutes) + 15
    }
  return formatDate(date, newTime);
}

export function createBodyGetCatalogues (e:any) {
  const  date = new  Date();
  const  age = date.getFullYear();

  const query={
    startLocation: e.detail.value.startLocation,
    endLocation: e.detail.value.endLocation,
    fromDate: formatDatePlus15(e.detail.value.pickupDate, e.detail.value.timePickupAux),
    toDate: formatDatePlus15(e.detail.value.dateReturn, e.detail.value.timeReturnAux),
    salePoint: "ES",
    driverAge: age-parseInt(e.detail.value.year),
    birthDate: e.detail.value.year+"-"+ e.detail.value.month+"-"+ e.detail.value.day
    }
    return query
}

export function mappingCollectedPoints(data:any) {
  const placesList = data.data.stopLocationOrCoordLocation.map(
    (place: any) => {
      return {
        place: place.CoordLocation.LocationNotes.LocationNote,
        coordinates: {
            lat: place.CoordLocation.lat,
            lon: place.CoordLocation.lon
        }
      };
    }
  );

  const placeObjects: { name: any; location: any; returnInfo: any; info: any; pickupInfo: any; }[] = [];
  const info = []

  for (const key in placesList) {
    if (placesList.hasOwnProperty(key)) {
      const data = placesList[key];
      let location: string | null = null;
      let returnInfo: string | null = null;
      let pickupInfo: any | null = null;
      let locationCode: string | null = null;
      let name: string | null = null;
      let coordinates: object = placesList[key].coordinates;
      const openings: null[] = [];      
      
      data.place.forEach((entry: { key: string; value: null }) => {       

        if (entry.key === "STATION_NAME") {
          location = entry.value;
        }
        if (entry.key === "RETURN_INFO") {
          returnInfo = entry.value          
        }

        if (entry.key === "PICKUP_INFO") {
          pickupInfo = entry.value
        }
        if (entry.key.includes('OPENING')) {
          openings.push(entry.value);
          info.push(entry.value);
        }

        if (entry.key === "externalId") {
            locationCode = entry.value
          }

        if (entry.key === "PLACE_NAME") {
            name = entry.value;
          
        }
      });      
      const placeObject = {
                  name: name,
                  location: location,
                  pickupInfo: pickupInfo,
                  returnInfo: returnInfo,
                  info: openings,
                  coordinates: coordinates,
                  locationCode: locationCode
                };
                placeObjects.push(placeObject);
    }
  }
  return placeObjects

}


export function secureMapping(amount:any) {
  let result="";

  if(amount==="0.00"){
    result="0 €"
  }else{
    result="+"+amount.replace('.', ',')+" €"
  }

return result;
}
export function unitKeyMapping(key:any,amount:any,t:any) {
  let result="";

  switch (key) {
      case 'day/driver':
      case 'day/unit':
      case 'day':
        if(amount==="0.00"){
          result="0 €"
        }else{
          result=amount.replace('.', ',')+t("unitKeyMapping.day")
        }

      break;
      case 'total':
        result=amount.replace('.', ',')+" €"
      break;
      case 'one-time':
        result="0 €"
      break;
    
  
    default:
      result=key;
      break;
  }

  return result

}
